<template>
  <div v-if="benchmarks && tov && benchmarkContent">
    <v-stepper v-model="e1">
      <v-stepper-header>
        <template v-for="(benchmark, index) in benchmarks">
          <v-stepper-step
            color="amber"
            :key="`step-${benchmark.id}`"
            :complete="e1 > index"
            :step="index + 1"
            @click="el = 1"
            >{{ index + 1 }}</v-stepper-step
          >
          <v-divider :key="`divider-${benchmark.id}`"></v-divider>
        </template>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content
          v-for="(benchmark, index) in benchmarks"
          :key="`content-${benchmark.id}`"
          :step="index + 1"
        >
          <v-row dense class="mb-10">
            <v-col cols="5" v-if="getBenchmarkRef(benchmark)">
              <v-img
                v-if="getBenchmarkRef(benchmark).src"
                class="white--text logo"
                :src="getBenchmarkRef(benchmark).src"
                height="250"
                width="250"
              ></v-img>
              <h5 class="mt-5">{{ benchmark.title }}</h5>
              <!-- <h4
                class="title mt-4 mb-2"
                v-if="getBenchmarkRef(benchmark).visionTitle"
              >
                {{ getBenchmarkRef(benchmark).visionTitle }}
              </h4> -->
              <p
                v-if="getBenchmarkRef(benchmark).vision"
                v-text="getBenchmarkRef(benchmark).vision"
                class="body-1 font-weight-regular mb-5 break-spaces"
              ></p>
              <div v-if="getBenchmarkRef(benchmark).collections">
                <h5>Collections</h5>
                <!-- <h3
                  class="pb-0"
                  v-if="getBenchmarkRef(benchmark).collectionsTitle"
                >
                  {{ getBenchmarkRef(benchmark).collectionsTitle }}
                </h3> -->
                <p
                  class="break-spaces"
                  v-text="getBenchmarkRef(benchmark).collections"
                ></p>
              </div>
              <div v-if="getBenchmarkRef(benchmark).social">
                <h5>Social</h5>
                <!-- <h4
                  class="mt mb-2 mt-10"
                  v-if="getBenchmarkRef(benchmark).socialTitle"
                >
                  {{ getBenchmarkRef(benchmark).socialTitle }}
                </h4> -->
                <p
                  class="break-spaces"
                  v-text="getBenchmarkRef(benchmark).social"
                ></p>
              </div>
            </v-col>
            <v-col cols="6" offset="1">
              <v-simple-table dark class="">
                <template v-slot:default>
                  <tov-header></tov-header>
                  <tbody>
                    <tov-row
                      from="Funny"
                      to="Serious"
                      v-model="tov[`ex${index + 1}`].row1"
                    ></tov-row>
                    <tov-row
                      from="Formal"
                      to="Casual"
                      v-model="tov[`ex${index + 1}`].row2"
                    ></tov-row>
                    <tov-row
                      from="Respectful"
                      to="Irreverent"
                      v-model="tov[`ex${index + 1}`].row3"
                    ></tov-row>
                    <tov-row
                      from="Enthusiastic"
                      to="Matter of fact"
                      v-model="tov[`ex${index + 1}`].row4"
                    ></tov-row>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
          <bottom-navigation
            :save="true"
            :next="showNext(index)"
            :prev="showPrev(index)"
            :gridView="false"
            :gridToggle="false"
            @save="saveExercise"
            @prev="prevStep"
            @next="nextStep"
          >
          </bottom-navigation>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-dialog v-model="dialog" max-width="450">
      <v-card>
        <v-card-title
          class="headline"
          v-text="$t('exercise_tov.saved.title')"
        ></v-card-title>

        <v-card-text
          v-text="$t('exercise_tov.saved.description')"
        ></v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="dialog = false">
            Close
          </v-btn>

          <v-btn
            color="amber accent-1"
            text
            :to="`/users/project/${this.$route.params.id}`"
          >
            Back to Project
          </v-btn>
          <v-btn color="amber accent-1" text to="/users/dashboard">
            Back to Dashboard
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation, TovRow, TovHeader } from "@/components/core";
const fb = require("@/firebaseConfig.js");
export default {
  name: "UserTov",
  data() {
    return {
      list: null,
      shortlist: [],
      benchmarkContent: [],
      e1: 1,
      dialog: false,
      exercise: null,
      tov: null,
      componentReady: false,
      intervalId: null,
    };
  },
  components: {
    BottomNavigation,
    TovRow,
    TovHeader,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    benchmarks() {
      return this.currentProjectModel.benchmarksOrder;
    },
    benchmarksLength() {
      return this.currentProjectModel.benchmarksOrder.length;
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.init();
    next();
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let vm = this;
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.intervalId = setInterval(function() {
        vm.checkStatus();
      }, 300);
    },
    checkStatus() {
      if (
        this.currentProjectModel &&
        this.currentProjectModel.benchmarksOrder
      ) {
        this.componentReady = true;
        clearInterval(this.intervalId);
        this.prePopulate();
      }
    },
    nextStep() {
      this.e1++;
      this.saveExercise(false);
    },
    prevStep() {
      this.e1--;
      this.saveExercise(false);
    },
    showNext(val) {
      return val < this.currentProjectModel.benchmarksOrder.length - 1
        ? true
        : false;
    },
    showPrev(val) {
      return val > 0 ? true : false;
    },
    prePopulate() {
      let tov = {};
      let count = 1;
      this.currentProjectModel.benchmarksOrder.forEach(() => {
        tov[`ex${count}`] = {
          row1: 0,
          row2: 0,
          row3: 0,
          row4: 0,
        };
        count++;
      });
      this.tov = tov;
      this.getExercise();
      this.getBenchmarks();
    },
    getExercise() {
      console.log("get exercise");
      let ref = fb.tovExCollection
        .where("uid", "==", `${this.currentUser.uid}`)
        .where("pid", "==", this.currentProjectModel.id);
      ref
        .get()
        .then((docs) => {
          let items = [];
          docs.forEach((docs) => {
            let doc = docs.data();
            items.push(doc);
          });
          if (items.length) {
            this.exercise = items[0];
            // load in the saved tov
            this.mergeArrays(this.exercise.tov);
          }
        })
        .catch((error) => {
          console.log("no document", error);
        });
    },
    getBenchmarkRef(entry) {
      return this.benchmarkContent.find((x) => x.id === entry.id);
    },
    getBenchmarks() {
      console.log("get benchmarks");
      let ref = fb.benchmarksCollection;
      ref
        .get()
        .then((docs) => {
          let items = [];
          docs.forEach((docs) => {
            let doc = docs.data();
            items.push(doc);
          });
          if (items.length) {
            this.benchmarkContent = items;
          }
        })
        .catch((error) => {
          console.log("no benchmarks", error);
        });
    },
    mergeArrays(arr) {
      Object.entries(arr).forEach(([outerKey, value]) => {
        Object.entries(value).forEach(([key, value]) => {
          this.tov[outerKey][key] = value;
        });
      });
    },
    saveExercise(notify) {
      // check if exercise exists
      let ref;
      let vm = this;
      if (this.exercise == null) {
        ref = fb.tovExCollection.doc();
      } else {
        ref = fb.tovExCollection.doc(this.exercise.id);
      }
      ref
        .set({
          updatedOn: new Date(),
          id: ref.id,
          uid: this.currentUser.uid,
          pid: this.currentProjectModel.id,
          tov: this.tov,
        })
        .then(() => {
          vm.exercise = {
            updatedOn: new Date(),
            id: ref.id,
            uid: this.currentUser.uid,
            pid: this.currentProjectModel.id,
            tov: this.tov,
          };
          if (notify) {
            vm.dialog = true;
          }
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
  },
};
</script>

<style lang="scss">
.canvas {
  position: relative;
  width: 100%;
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: grey;
  &__tile {
    width: 200px;
    height: 200px;
    background-size: cover;
    background-position: center;
    margin: 2px;
  }
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
